import React, { useEffect, useState, useRef } from "react";
import Navbar from "../dashboard/navbar";
import { toast } from "react-toastify";
import Spinner from "../Spinner";
import "../Admin.css";
import MainTopNav from "../maintopnav";
import Modal from "./Modal";
import { FiSearch } from "react-icons/fi";
import SessionExpiredModal from "../401";
function Transactions() {
    const fromref = useRef();
    const statusref = useRef();
    const pgref = useRef();
    const searchref = useRef();
    const toref = useRef();
    const [disableType, setDisableType] = useState("");
    const token = JSON.parse(sessionStorage.getItem("token"));
    const [spinner, setSpinner] = useState(true);
    const [WalletTransactions, setWalletTransactions] = useState([]);
    const [prevOffset, setPrevOffset] = useState(0);
    const [currentOffset, setCurrentOffset] = useState();
    const [modal, setmodal] = useState(false);
    const [key, setkey] = useState("");
    const [offset, setoffset] = useState();
    const [prevdisable, setprevdisable] = useState(false);
    const [nextdisable, setnextdisble] = useState(false);
    // const [searchload, setSearchload] = useState(true);
    const [sessionExpired, setSessionExpired] = useState(false);
    let offsetState;
    useEffect(() => {
        offsetState = true;
    }, []);
    console.log(nextdisable);
    const gettransaction = (data) => {
        setSpinner(true);
        fetch(
            `${process.env.REACT_APP_BASE_URL}/admin/debit-transactions?Offset=${data.offset}`,
            {
                method: "POST",
                body: JSON.stringify({ ...data }),
                headers: {
                    "content-type": "application/json;charset =UTF-8",
                    Authorization: `token ${token}`,
                },
            }
        )
            .then((Response) => Response.json())
            .then((response) => {
                console.log(response);
                if (response.Status === 1) {
                    setWalletTransactions(response.WalletTransactions);
                    setCurrentOffset(response.Offset);
                    if (offset == response.Offset) {
                        setprevdisable(true);
                    }
                    if (response.Offset == -1) {
                        setnextdisble(true);
                    }
                    if (offsetState) {
                        setoffset(response.Offset);
                        offsetState = false;
                        setprevdisable(true);
                    }
                }
                if (response.Status === 0) {
                    if (response.Message === "Invalid Token") {
                        setSessionExpired(true);
                        return;
                    }
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    });
                }
                setSpinner(false);
            })
            .catch((err) => {
                setSpinner(false);
                toast.error(
                    `something went Wrong please try again after sometime`,
                    {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    }
                );
            });
    };
    useEffect(() => {
        gettransaction({ offset: 0 });
    }, [token]);
    const transactionsHandler = () => {
        // fromDate: `${current.getFullYear()}-${current.getMonth()}-${current.getDay()}`,
        //     toDate: `${to.getFullYear()}-${to.getMonth()}-${to.getDay()}`,
        const current = new Date(fromref.current.value);
        const to = new Date(toref.current.value);

        let Body = { offset: 0, fromDate: current, toDate: to };
        // if (disableType === "STATUS") {
        //     Body = { ...Body, paymentgateway: pg, transactionType: 1 };
        // } else if (disableType === "PG") {
        //     Body = { ...Body, transactionStatus: status, transactionType: 2 };
        // }

        gettransaction({
            ...Body,
        });
    };
    const prevHandler = () => {
        const current = new Date(fromref.current.value);
        const to = new Date(toref.current.value);
        if (prevOffset === 0) {
            return;
        }
        setnextdisble(false);

        let Body = {
            offset: prevOffset - offset,
            fromDate: current,
            toDate: to,
        };

        gettransaction({
            ...Body,
        });

        setPrevOffset(prevOffset - offset);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    const nexthandler = () => {
        const current = new Date(fromref.current.value);
        const to = new Date(toref.current.value);
        if (currentOffset !== -1) {
            setprevdisable(false);
            setPrevOffset(currentOffset);
            const pg = pgref.current.value;
            const status = statusref.current.value;

            let Body = { offset: currentOffset, fromDate: current, toDate: to };
            if (disableType === "STATUS") {
                Body = { ...Body, paymentgateway: pg, transactionType: 1 };
            } else if (disableType === "PG") {
                Body = {
                    ...Body,
                    transactionStatus: status,
                    transactionType: 2,
                };
            }
            gettransaction({
                ...Body,
            });
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    const modalhandler = (e) => {
        setkey(e.currentTarget.getAttribute("id"));
        setmodal(true);
    };
    const searchHandler = (e) => {
        setSpinner(true);
        // console.log(searchref.current.value);
        // return;
        fetch(
            `${process.env.REACT_APP_BASE_URL}/admin/debit-transactions?Offset=0
`,
            {
                method: "POST",
                body: JSON.stringify({ orderId: searchref.current.value }),
                headers: {
                    "content-type": "application/json;charset =UTF-8",
                    Authorization: `token ${token}`,
                },
            }
        )
            .then((Response) => Response.json())
            .then((response) => {
                console.log(response);
                if (response.Status === 1) {
                    setprevdisable(true);
                    setnextdisble(true);
                    if (response?.WalletTransactions) {
                        setWalletTransactions(response.WalletTransactions);
                    } else {
                        setWalletTransactions([]);
                    }
                }
                setSpinner(false);
            })
            .catch((err) => {
                setSpinner(false);
                toast.error(
                    `something went Wrong please try again after sometime`,
                    {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    }
                );
            });
    };
    const ClearHandler = () => {
        offsetState = true;
        setprevdisable(false);
        setnextdisble(false);
        gettransaction({ offset: 0 });
        searchref.current.value = "";
    };
    const resetForm = () => {
        pgref.current.value = "";
        fromref.current.value = "";
        toref.current.value = "";
        statusref.current.value = "";
        setDisableType("");
        gettransaction({
            offset: prevOffset,
        });
    };
    const refreshHandler = () => {
        const fromDate = fromref.current.value;
        const ToDate = toref.current.value;
        if (fromDate && ToDate) {
            const current = new Date(fromref.current.value);
            const to = new Date(toref.current.value);

            let Body = {
                offset: prevOffset ? prevOffset : 0,
                fromDate: current,
                toDate: to,
            };

            gettransaction({
                ...Body,
            });
        } else {
            gettransaction({
                offset: prevOffset,
            });
        }
    };
    const exportHandler = () => {
        const fromDate = fromref.current.value;
        const ToDate = toref.current.value;
        let Body = { offset: prevOffset ? prevOffset : 0 };
        if (fromDate && ToDate) {
            const current = new Date(fromref.current.value);
            const to = new Date(toref.current.value);

            Body = {
                ...Body,
                fromDate: current,
                toDate: to,
            };
        }
        fetch(
            `${process.env.REACT_APP_BASE_URL}/admin/debit-transactions/csv?Offset=${Body.offset}`,
            {
                method: "POST",
                body: JSON.stringify(Body),
                headers: {
                    "content-type": "application/json;charset =UTF-8",
                    Authorization: `token ${token}`,
                },
            }
        )
            .then((Response) => Response.json())
            .then((response) => {
                console.log(response);
                if (response.Status === 1) {
                    //filename

                    fetch(response.fileName).then((response) => {
                        response.blob().then((blob) => {
                            // Creating new object of PDF file
                            const fileURL = window.URL.createObjectURL(blob);
                            // Setting various property values
                            let alink = document.createElement("a");
                            alink.href = fileURL;
                            alink.download = `Wallet-transactions.csv`;
                            alink.click();
                        });
                    });
                }
                if (response.Status === 0) {
                    if (response.Message === "Invalid Token") {
                        setSessionExpired(true);
                        return;
                    }
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                toast.error(
                    `something went Wrong please try again after sometime`,
                    {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                    }
                );
            });
    };
    return (
        <>
            {sessionExpired && <SessionExpiredModal />}
            {modal && <Modal setmodal={setmodal} id={key} />}
            <div className="ui">
                <div className="ui-leftside">
                    <div className="navbar">
                        <Navbar active="Wallet Debit Transactions" />
                    </div>
                </div>
                <div className="ui-rightside ">
                    <MainTopNav />
                    <div className="ui-wrapper">
                        <div className="Table" style={{ overflowX: "auto" }}>
                            <div
                                className="filter-wrapper"
                                style={{
                                    gridTemplateColumns: "1fr",
                                    gap: "1rem",
                                }}>
                                <div className="search-data">
                                    <input
                                        type={"text"}
                                        onChange={() => {
                                            fromref.current.value = "";
                                            toref.current.value = "";
                                        }}
                                        placeholder="Search by Order ID"
                                        ref={searchref}
                                    />
                                    <FiSearch
                                        className="search-icon"
                                        size={23}
                                        color="#6865f0"
                                    />
                                    <button onClick={searchHandler}>
                                        Search
                                    </button>
                                    <button
                                        onClick={ClearHandler}
                                        style={{ background: "red" }}>
                                        Clear
                                    </button>
                                    <div className="business-user-header">
                                        <button
                                            onClick={exportHandler}
                                            style={{
                                                backgroundColor: "#54215d",
                                            }}>
                                            export
                                        </button>
                                    </div>
                                </div>
                                <div className="dateinputs">
                                    <input
                                        type={"date"}
                                        ref={fromref}
                                        onChange={() =>
                                            (searchref.current.value = "")
                                        }
                                        max={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                    />
                                    <input
                                        type={"date"}
                                        ref={toref}
                                        onChange={() =>
                                            (searchref.current.value = "")
                                        }
                                        max={
                                            new Date()
                                                .toISOString()
                                                .split("T")[0]
                                        }
                                    />
                                    {/* <select
                                        ref={pgref}
                                        disabled={disableType === "PG"}
                                        onChange={(e) =>
                                            setDisableType(
                                                e.target.value.length > 0
                                                    ? "STATUS"
                                                    : ""
                                            )
                                        }>
                                        <option value="">Select PG</option>
                                        <option value="razorpay">
                                            Razorpay
                                        </option>
                                        <option value="pinelabs">
                                            PineLabs
                                        </option>
                                    </select> */}
                                    {/* <select
                                        ref={statusref}
                                        disabled={disableType === "STATUS"}
                                        onChange={(e) =>
                                            setDisableType(
                                                e.target.value.length > 0
                                                    ? "PG"
                                                    : ""
                                            )
                                        }>
                                        <option value="">
                                            Transaction Status
                                        </option>
                                        <option value="1">Success</option>
                                        <option value="2">Pending</option>
                                        <option value="3">Failed</option>
                                        <option value="4">Reversed</option>
                                    </select> */}
                                    <button onClick={transactionsHandler}>
                                        Go
                                    </button>
                                    <button onClick={refreshHandler}>
                                        Refresh
                                    </button>
                                    <button onClick={resetForm}>
                                        Reset Form
                                    </button>
                                </div>
                            </div>
                            {spinner ? (
                                <Spinner />
                            ) : (
                                <table>
                                    <thead>
                                        <tr>
                                            <td>Order ID</td>
                                            <td>Name</td>
                                            <td>Date</td>
                                            <td>Amount</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {WalletTransactions?.length > 0 ? (
                                            WalletTransactions.map((item) => {
                                                const datestring = String(
                                                    item.transactionDateTime
                                                ).split("T");
                                                const date = new Date(
                                                    datestring[0]
                                                );
                                                const month = date.toLocaleString(
                                                    "default",
                                                    { month: "short" }
                                                );
                                                const time = datestring[1].split(
                                                    ":"
                                                );
                                                return (
                                                    <tr
                                                        className="transactions-row "
                                                        key={
                                                            item.wallet_transactionId
                                                        }
                                                        id={
                                                            item.wallet_transactionId
                                                        }
                                                        // onClick={modalhandler}
                                                    >
                                                        <td>
                                                            {
                                                                item.razorpay_TransactionId
                                                            }
                                                        </td>
                                                        <td>
                                                            {" "}
                                                            {item.firstName}
                                                        </td>

                                                        <td>
                                                            {" "}
                                                            {String(
                                                                date.getDate()
                                                            ).padStart(
                                                                2,
                                                                "0"
                                                            )}{" "}
                                                            {month}{" "}
                                                            {date.getFullYear()}{" "}
                                                            {`${time[0]}:${time[1]}`}
                                                        </td>

                                                        <td> ₹{item.amount}</td>
                                                        {/* <td>
                                                            {" "}
                                                            {(item?.transactionType ===
                                                                2 ||
                                                                item?.transactionType ===
                                                                    3 ||
                                                                item?.transactionType ===
                                                                    6 ||
                                                                item?.transactionType ===
                                                                    8 ||
                                                                item?.transactionType ===
                                                                    9) && (
                                                                <span
                                                                    style={{
                                                                        color:
                                                                            "#F0532D",
                                                                        fontWeight: 500,
                                                                    }}>
                                                                    ₹
                                                                    {
                                                                        item?.amount
                                                                    }
                                                                </span>
                                                            )}
                                                        </td> */}
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={5}
                                                    style={{
                                                        fontWeight: 500,
                                                        textAlign: "center",
                                                    }}>
                                                    No Transactions Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td
                                                colSpan={6}
                                                style={{
                                                    textAlign: "right",
                                                }}>
                                                <button
                                                    className="controlButtons"
                                                    onClick={prevHandler}
                                                    disabled={prevdisable}>
                                                    Previous
                                                </button>
                                                <button
                                                    onClick={nexthandler}
                                                    className="controlButtons"
                                                    disabled={nextdisable}
                                                    style={{
                                                        marginLeft: "1rem",
                                                    }}>
                                                    Next
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Transactions;
